var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9969 39.8258C31.0887 39.8258 39.2697 31.6448 39.2697 21.5531C39.2697 11.4613 31.0887 3.28036 20.9969 3.28036C10.9052 3.28036 2.72421 11.4613 2.72421 21.5531C2.72421 31.6448 10.9052 39.8258 20.9969 39.8258ZM20.9969 40.9167C31.6912 40.9167 40.3606 32.2473 40.3606 21.5531C40.3606 10.8588 31.6912 2.18945 20.9969 2.18945C10.3027 2.18945 1.6333 10.8588 1.6333 21.5531C1.6333 32.2473 10.3027 40.9167 20.9969 40.9167Z",
    fill: "url(#paint0_linear_39727_43961)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9995 40.3719C31.3925 40.3719 39.8177 31.9467 39.8177 21.5537C39.8177 11.1607 31.3925 2.73553 20.9995 2.73553C10.6065 2.73553 2.18133 11.1607 2.18133 21.5537C2.18133 31.9467 10.6065 40.3719 20.9995 40.3719ZM20.9995 42.5537C32.5975 42.5537 41.9995 33.1517 41.9995 21.5537C41.9995 9.95573 32.5975 0.553711 20.9995 0.553711C9.40153 0.553711 -0.000488281 9.95573 -0.000488281 21.5537C-0.000488281 33.1517 9.40153 42.5537 20.9995 42.5537Z",
    fill: "url(#paint1_linear_39727_43961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39727_43961",
    x1: 20.9969,
    y1: 2.18945,
    x2: 20.9969,
    y2: 40.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#925417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#935920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39727_43961",
    x1: 21.2722,
    y1: 42.5537,
    x2: 21.2722,
    y2: -2.17356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#DA842F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#FFCA95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F9DFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#E49546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD6F22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.0cb4ed59377eb2c1d50334a4d7a64951.svg";
export { ForwardRef as ReactComponent };